import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class ClienteLimiteCreditoService {

    /** Verifica se o valor de referência informado excedeu o valor do limite de crédito disponível para o cliente */
    isLimiteCreditoDisponivelExcedido(valorReferencia: number, limiteCreditoDisponivel: number): boolean {
        valorReferencia = valorReferencia && !isNaN(valorReferencia) ? Number(valorReferencia) : 0;
        limiteCreditoDisponivel = limiteCreditoDisponivel && !isNaN(limiteCreditoDisponivel) ? Number(limiteCreditoDisponivel) : 0;

        return valorReferencia > limiteCreditoDisponivel;
    }
}
